import api from './index';
import userApi from './user';
//
import {CtrlParamCodes} from '../app.const';
//
let exports = {};

let getMerchantCtrlParamValueSyncExt = function ({merchantId = null, merchantType = null, paramCode}) {
    //
    let theVipLevel = null;
    //
    let postData = {};
    postData.code = paramCode;
    postData.merchantId = merchantId;
    postData.merchantType = merchantType;
    exports.getMerchantCtrlParamValueSync(postData, function (result) {
        if (result.type == 'info') {
            theVipLevel = result.data;
        }
    });
    return theVipLevel;
};

exports.getMerchantCtrlParamValueSyncExt = getMerchantCtrlParamValueSyncExt;

exports.checkCtxMerchantVipLevel = function (paramCode, featureName = null) {
    //（根据上下文用户信息获取）当前商户的vip级别
    let ctxVipLevel = userApi.getScopeEntityVipLevel();
    //获取指定特性控制参数vip级别
    let theVipLevel = getMerchantCtrlParamValueSyncExt({paramCode});
    //
    if (theVipLevel == null || ctxVipLevel >= theVipLevel) {
        return null;
    } else {
        let vipLevel = getEnumMap("vipLevel", "value2text");
        let vipLevelName = vipLevel[theVipLevel] || ''; //（根据枚举获取）vip级别名称
        return (featureName == null ? "此功能" : featureName) + "受限（所需vip级别为【" + vipLevelName + "】）"
    }
};

exports.checkVipLevelForAddCom = function (comLevel) {
    let paramCode = CtrlParamCodes['VIP_VALVE_FOR_ORG_LEVEL_' + comLevel];
    //
    let featureName = "添加" + comLevel + "级公司";
    //
    return exports.checkCtxMerchantVipLevel(paramCode, featureName);
};

// 控制参数
exports.getMerchantCtrlParamValue = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/ctrl/param/value/get')
        .data(data)
        .done(callback)
        .go();
};
// 集团控制参数
exports.getRealCtrlParamValue = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/real/ctrl/param/value/get')
        .data(data)
        .done(callback)
        .go();
};

// 业务参数
exports.getMerchantBizParamValue = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/biz/param/value/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getMerchantCtrlParamValueSync = function (data, callback) {// 根据code获取控制参数值
    api.post('/merchtComn/merchant/ctrl/param/value/get')
        .sync(true)
        .data(data)
        .done(callback)
        .go();
};

//
exports.getBizTplList = function (data, callback) {// 查询业务模板列表
    api.post('/merchtComn/biz/tpl/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 反馈类型列表
exports.getFeedbackTypeList = function (postData, callback) {// 获取反馈类型
    api.post('/merchtComn/feedback/type/list/get')
        .data(postData)
        .done(callback)
        .go();
};

// 保存
exports.saveFeedback = function (params, callback) {// 添加问题反馈
    api.post('/merchtComn/feedback/save/do')
        .data(params)
        .done(callback)
        .go();
};

// 反馈分页列表
exports.getFeedbackList = function (params, callback) {// 获取反馈分页列表
    api.post('/merchtComn/feedback/list/get')
        .data(params)
        .done(callback)
        .go();
};

//=================== 历史查询 =======================
let cachedHisQueryConfMap = {}; //查询配置缓存
//根据id获取历史元设查询（结果）配置信息（带客户端缓存）
exports.getHisMetaQueryResultConfById = function (id, callback) {
    if (id == null || id < 0) {
        return null;
    }
    //优先使用缓存
    let cacheKey = (id || null) + '';
    let cachedResult = cachedHisQueryConfMap[cacheKey];
    if (cachedResult == null) {
        api.get('/merchtComn/his/meta/query/result/conf/get/by/id')
            .params({
                id: id || null
            })
            .done(function (result) {
                if (result.success && result.data != null) {
                    cachedHisQueryConfMap[cacheKey] = result;
                }
                //
                callback(result);
            })
            .fail(callback)
            .go();
    } else {
        callback(cachedResult);
    }
};

//===================商户业务关系======================
exports.getMerchantBizRelListUnbacked = function (params, callback) {// 获取商户业务关系列表及其他信息
    api.post('/merchtComn/merchant/biz/rel/list/unbacked/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantBizRelListX = function (params, callback) {// 获取商户业务关系列表
    api.post('/merchtComn/merchant/biz/rel/list/getX')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getMerchantBizRelList = function (params, callback) {// 获取商户业务关系列表
    api.post('/merchtComn/merchant/biz/rel/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantBizRel = function (params, callback) {// 获取商户业务关系
    api.post('/merchtComn/merchant/biz/rel/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantBizRel = function (params, callback) {// 保存商户业务关系
    api.post('/merchtComn/merchant/biz/rel/save/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantBizRelSinge = function (params, callback) {// 保存商户业务关系
    api.post('/merchtComn/merchant/biz/rel/singe/save/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.updateMerchantBizRel = function (params, callback) {// 更新商户业务关系信息
    api.post('/merchtComn/merchant/biz/rel/update/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantBizRel = function (params, callback) {// 刪除商户业务
    api.post('/merchtComn/merchant/biz/rel/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

/** 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户id子集 */
exports.getMerchantBizRelPeerMerchantIds = function (data, callback) {// 获取商户类型的（存在于给定的关系商户id列表中的）关系商户ids
    api.post('/merchtComn/merchant/biz/rel/peerMerchantIds/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getQualiTypeListBymerchantType = function (params, callback) {// 根据不同商户查看不同的资质类型
    api.get('/merchtComn/quali/type/list/get/by/merchantType')
        .params(params)
        .done(callback)
        .go();
};

exports.updateMerchantBizRelBizTagByIds = function (data, callback) {// 根据资质类型code查询资质属性
    api.post('/merchtComn/merchant/biz/rel/bizTag/update/by/ids')
        .data(data)
        .done(callback)
        .go();
};
exports.updateMerchantBizRelBizTagById = function (data, callback) {// 根据资质类型code查询资质属性
    api.post('/merchtComn/merchant/biz/rel/bizTag/update/by/id')
        .data(data)
        .done(callback)
        .go();
};

//
exports.getQualiType = function (data, callback) {// 根据资质类型id查询资质属性
    api.get('/merchtComn/quali/type/get')
        .params(data)
        .done(callback)
        .go();
};

exports.getQualiTypeByCode = function (data, callback) {// 根据资质类型code查询资质属性
    api.get('/merchtComn/quali/type/get/by/code')
        .params(data)
        .done(callback)
        .go();
};

//==========================商户业务参数==========================
exports.getBizParamGroupList = function (data, callback) {// 查询业务参数分组
    api.post('/merchtComn/biz/param/group/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantBizParams = function (data, callback) {// 批量保商户业务存参数
    api.post('/merchtComn/merchant/biz/params/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//交易规则列表
exports.getTradeRuleList = function (params, callback) {// 交易规则列表
    api.post('/merchtComn/trade/rule/list/get')
        .data(params)
        .done(callback)
        .go();
};

// ====================================== 人员资质类型 ===========================
// 【人员资质类型】分页列表
exports.getStaffQualiTypesByFilter = function (data, callback) {
    api.post('/merchtComn/staff/quali/type/list/page/get')
        .data(data)
        .done(callback)
        .go();
};
// 【人员资质类型】查询
exports.getStaffQualiTypeInfo = function (data, callback) {
    api.post('/merchtComn/staff/quali/type/info/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getStaffQualiTypeLevelListByTypeId = function (params, callback) {// 根据人员资质类型id 获取人员资质类型等级列表
    api.get('/merchtComn/staff/quali/type/level/list/get/by/typeId')
        .params(params)
        .done(callback)
        .go();
};
// ============================ 专用二维码管理 ============================
exports.getDdctQrcodePageList = function (data, callback) {     // 获取二维码列表
    api.post('/merchtComn/ddct/qrcode/page/list')
        .data(data)
        .done(callback)
        .go();
};
//
exports.saveOrGetDdctQrcode = function (data, callback) {     // 查询且新增二维码
    api.post('/merchtComn/ddct/qrcode/info/get/or/save')
        .data(data)
        .done(callback)
        .go();
};
//
exports.saveDdctQrcode = function (data, callback) {     // 新增二维码列表
    api.post('/merchtComn/ddct/qrcode/save/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.upateDdctQrcodeForInvalid = function (data, callback) {     // 作废二维码列表
    api.post('/merchtComn/ddct/qrcode/update/for/invalid/do')
        .data(data)
        .done(callback)
        .go();
};
// ======= 零售商经营业态 =======

exports.getRetailerBizFormPageList = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getRetailerBizFormList = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/list/get/for/select')
        .data(data)
        .done(callback)
        .go();
};
exports.saveRetailerBizForm = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateRetailerBizForm = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.doValidateRetailerBizFormCanDisabled = function (data, callback) {
    api.get('/merchtComn/retailer/biz/form/validate/do')
        .params(data)
        .done(callback)
        .go();
};
exports.updateRetailerBizFormForDisabled = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/update/for/disabled/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteRetailerBizForm = function (data, callback) {
    api.post('/merchtComn/retailer/biz/form/delete/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.getMgmtAreaTreeList = function (data, callback) {
    api.post('/merchtComn/retailer/mgmt/area/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.saveRetailerMgmtArea = function (data, callback) {
    api.post('/merchtComn/retailer/mgmt/area/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateRetailerMgmtForm = function (data, callback) {
    api.post('/merchtComn/retailer/mgmt/area/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.moveRetailerBizFormDo = function (data, callback) {
    api.post('/merchtComn/retailer/mgmt/area/move/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteRetailerMgmtArea = function (data, callback) {
    api.post('/merchtComn/retailer/mgmt/area/delete/do')
        .data(data)
        .done(callback)
        .go();
};
exports.getRetailerMgmtAreaByParentId = function (params, callback) {
    api.get('/merchtComn/retailer/mgmt/area/get/by/parentId')
        .params(params)
        .done(callback)
        .go();
};

// ================== 财务业务类型 ==================

exports.getFinacBizTypePagesList = function (data, callback) {
    api.post('/merchtComn/finac/biz/type/pages/list/get')
        .data(data)
        .done(callback)
        .go();
};

// ================== 商户业务类型 ==================

exports.getMerchtBizTypeInfo = function (params, callback) {
    api.get('/merchtComn/mercht/biz/type/info/get')
        .params(params)
        .done(callback)
        .go();
};
exports.getMerchtBizTypePagesList = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/pages/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.saveMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteMerchtBizType = function (data, callback) {
    api.post('/merchtComn/mercht/biz/type/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// ================== 实体公司 ==================
exports.getRealCom = function (data, callback) {
    api.get('/merchtComn/real/com/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getRealComByCode = function (data, callback) {
    api.get('/merchtComn/real/com/get/by/code')
        .params(data)
        .done(callback)
        .go();
};
exports.getRealComList = function (data, callback) {
    api.post('/merchtComn/real/com/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.saveRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteRealCom = function (data, callback) {
    api.post('/merchtComn/real/com/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// ================== 实体商户 ==================
exports.getRealMerchantInfoByCode = function (data, callback) {
    api.get('/merchtComn/real/merchant/info/get/by/code')
        .params(data)
        .done(callback)
        .go();
};

// ================== 自定义纳税类型 ==================

// 获取自定义纳税类型分页列表
exports.getCustTaxPayTypeList = function (data, callback) {
    api.post('/merchtComn/cust/tax/pay/type/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取自定义纳税类型分页列表
exports.getCustTaxPayTypeByCode = function (params/*realMerchantId：实体商户id（非必传），code：自定义纳税类型编码（必传）*/, callback) {
    api.get('/merchtComn/cust/tax/pay/type/get/by/code')
        .params(params)
        .done(callback)
        .go();
};
// 保存自定义纳税类型
exports.saveCustTaxPayType = function (data, callback) { //
    api.post('/merchtComn/cust/tax/pay/type/save')
        .data(data)
        .done(callback)
        .go();
};
// 获取自定义纳税类型
exports.getCustTaxPayTypeById = function (params, callback) {
    api.get('/merchtComn/cust/tax/pay/type/get/by/id')
        .params(params)
        .done(callback)
        .go();
};
// 删除自定义纳税类型
exports.deleteCustTaxPayType = function (data, callback) {
    api.post('/merchtComn/cust/tax/pay/type/delete')
        .data(data)
        .done(callback)
        .go();
};

// 获取购置可抵税标识
exports.getTaxDeductible = function (params/*buyerId：买家商户id（必传），invoiceType：卖家发票类型（必传）*/, callback) {
    api.get('/merchtComn/tax/deductible/get/by/buyerId/and/invoiceType')
        .params(params)
        .done(callback)
        .go();
};
// 获取购置可抵税标识
exports.getCenterByRealComId = function (data, callback) {
    api.post('/merchtComn/center/get/realComId')
        .data(data)
        .done(callback)
        .go();
};

// ================ 布放区 ==================
// 获取布放区树列表
exports.getRetailerLayoutAreaTreeList = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/tree/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取布放区分页列表
exports.getRetailerLayoutAreaListByFilter = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取零售商布放区
exports.getRetailerLayoutArea = function (id, callback) {
    api.get('/merchtComn/retailer/layout/area/get')
        .params({
            id: id
        })
        .done(callback)
        .go();
};
// 保存零售商布放区
exports.saveRetailerLayoutArea = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 启禁用零售商布放区
exports.updateRetailerLayoutAreaDisabled = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/disabled/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 删除零售商布放区
exports.deleteRetailerLayoutArea = function (id, callback) {
    api.post('/merchtComn/retailer/layout/area/delete/do')
        .data({
            id: id
        })
        .done(callback)
        .go();
};
// 设置零售商布放区首要设备
exports.updateRetailerLayoutAreaDevcInfo = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/devcInfo/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 零售商布放区排序
exports.moveUpOrDownRetailerLayoutArea = function (data, callback) {
    api.post('/merchtComn/retailer/layout/area/move/up/or/down')
        .data(data)
        .done(callback)
        .go();
};
// ================== 布放区楼层 ========================

exports.getRetailerLayoutFloorPageList = function (data, callback) {
    api.post('/merchtComn/retailer/layout/floor/page/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getRetailerLayoutFloorList = function (data, callback) {
    api.post('/merchtComn/retailer/layout/floor/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.saveRetailerLayoutFloor = function (data, callback) {
    api.post('/merchtComn/retailer/layout/floor/save/do')
        .data(data)
        .done(callback)
        .go();
};

exports.moveRetailerLayoutFloor = function (data, callback) {
    api.post('/merchtComn/retailer/layout/floor/move/do')
        .data(data)
        .done(callback)
        .go();
};

exports.deleteRetailerLayoutFloor = function (data, callback) {
    api.post('/merchtComn/retailer/layout/floor/delete/do')
        .data(data)
        .done(callback)
        .go();
};

// ================== 设备归类标签 ========================
//
exports.getDevcClassifyTagPageList = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/page/list/get')
        .data(data)
        .done(callback)
        .go();
};
//
exports.saveDevcClassifyTag = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/save/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.deleteDevcClassifyTag = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/delete/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.getDevcClassifyTagSpecFields = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/spec/field/list/get')
        .data(data)
        .done(callback)
        .go();
};
//
exports.saveDevcClassifyTagSpecFields = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/spec/field/save/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.deleteDevcClassifyTagSpecFieldById = function (data, callback) {
    api.post('/merchtComn/devc/classify/tag/spec/field/delete/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.doDevcClassifyTagSpecFieldMove = function (data, callback) {
    api.post('/merchtComn/devc/calssify/tag/spec/field/move/do')
        .data(data)
        .done(callback)
        .go();
};
//
// ================== 设备自定义字段 ========================
exports.getDevcCustFieldPageList = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/page/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getDevcCustFieldList = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getDevcCustFieldById = function (data, callback) {
    api.get('/merchtComn/devc/cust/field/get')
        .params(data)
        .done(callback)
        .go();
};
exports.saveDevcCustField = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateDevcCustField = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteDevcCustField = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/delete/do')
        .data(data)
        .done(callback)
        .go();
};
exports.doDevcCustFieldMove = function (data, callback) {
    api.post('/merchtComn/devc/cust/field/move/do')
        .data(data)
        .done(callback)
        .go();
};

// 银行账号列表
exports.getRealComBankAcctList = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
// 银行账号查询
exports.getRealComBankAcctById = function (params, callback) {
    api.get('/merchtComn/real/com/bank/acct/get/id')
        .params(params)
        .done(callback)
        .fail(callback)
        .go()
};
// 默认银行账号
exports.getRealComBankAcctDefaulted = function (params, callback) {
    api.post('/merchtComn/real/com/bank/acct/defaulted/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go()
};

/* 银行账号保存 */
exports.saveRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/save')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
exports.updateRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
/* 银行账号删除 */
exports.deleteRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/delete')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
/* 银行账号锁定 */
exports.updateRealComBankAcctLocked = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/lock/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
exports.updateRealComBankAcctUnLocked = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/unlock/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
/* 银行账号冻结*/
exports.updateRealComBankAcctFrozen = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/frozen')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
exports.updateRealComBankAcctUnFrozen = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/unfrozen')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
// 设置默认
exports.doDefaultedRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/defaulted')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};
exports.validateImpFileRepetition = function (data, callback) {
    api.post('/merchtComn/imp/file/real/com/bank/validate')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
exports.saveRealComBankAcctList = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/list/save')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
exports.doEnableRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/enable')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}
exports.doDisableRealComBankAcct = function (data, callback) {
    api.post('/merchtComn/real/com/bank/acct/disable')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
}

exports.getMerchantRealComList = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.saveMerchantRealCom = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteMerchantRealCom = function (data, callback) {
    api.post('/merchtComn/merchant/real/com/delete/do')
        .data(data)
        .done(callback)
        .go();
};

// 合同新增实体入围公司
exports.saveRealAdoptedComForContract = function (data, callback) {
    api.post('/merchtComn/real/adopted/com/save/for/contract')
        .data(data)
        .done(callback)
        .go();
};

// =========================== 签约组 ================================

exports.getRealSignGroupPageList = function (data, callback) {
    api.post('/merchtComn/real/sign/group/page/list/get')
        .data(data)
        .done(callback)
        .go()
};

// 签约明细
exports.getRealSignGroupInfo = function (params, callback) {
    api.get('/merchtComn/real/sign/group/by/id')
        .params(params)
        .done(callback)
        .go()
};

// 签约下级明细列表
exports.getRealSignComList = function (params, callback) {
    api.get('/merchtComn/real/sign/com/list/get')
        .params(params)
        .done(callback)
        .go()
};

// =========================== 公司业务参数 ================================

exports.getComBizParamGroupList = function (data, callback) {
    api.post('/merchtComn/com/biz/param/group/list/get')
        .data(data)
        .done(callback)
        .go()
};

exports.getComBizParamList = function (data, callback) {
    api.post('/merchtComn/com/biz/param/list/get')
        .data(data)
        .done(callback)
        .go()
};

exports.getMerchtImpTplDlInfo = function (data, callback) {
    api.get('/merchtComn/mercht/imp/tpl/dlInfo/get')
        .params(data)
        .done(callback)
        .go()
}

exports.getRealAdoptedComList = function (data, callback) {
    api.post('/merchtComn/real/adopted/com/list/get')
        .data(data)
        .done(callback)
        .go()
}

// ========================= 成本中心折旧分摊组 ================================

// 成本中心折旧分摊组列表
exports.getCostCenterDeprAllocGroupList = function (data, callback) {
    api.post('/merchtComn/cost/center/depr/alloc/group/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtComn.js
// module id = 13
// module chunks = 0